var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.orders, function(order, index) {
        return [
          _c(
            "span",
            {
              staticClass: "badge badge-secondary",
              staticStyle: { "margin-right": "5px" }
            },
            [
              _vm._v("\n      " + _vm._s(order.item) + "\n      "),
              _vm._v(" "),
              order.modifiers
                ? [
                    order.modifiers.length > 0
                      ? [
                          _vm._v("\n          ("),
                          _vm._l(order.modifiers, function(modifier, idx) {
                            return [
                              _vm._v(_vm._s(modifier.option)),
                              idx < order.modifiers.length - 1
                                ? _c("span", [_vm._v(", ")])
                                : _vm._e()
                            ]
                          }),
                          _vm._v(")\n        ")
                        ]
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm._v("\n      x" + _vm._s(order.quantity) + "\n      "),
              _vm._v(" "),
              _vm.isShowPrice
                ? _c("span", { staticClass: "badge badge-light" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.currencyFormatter(_vm.getPrice(order), {
                            code: _vm.currency
                          })
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("br")
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dd6ac22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd6ac22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/ItemList.vue
// module id = null
// module chunks = 